const FETCH_SHOP_COLLECTION_REQUEST = 'FETCH_SHOP_COLLECTION_REQUEST'
const FETCH_SHOP_COLLECTION_SUCCESS = 'FETCH_SHOP_COLLECTION_SUCCESS'
const FETCH_SHOP_COLLECTION_FAILURE = 'FETCH_SHOP_COLLECTION_FAILURE'
const UPDATE_SHOP_COLLECTION = 'UPDATE_SHOP_COLLECTION'

export {
  FETCH_SHOP_COLLECTION_REQUEST,
  FETCH_SHOP_COLLECTION_SUCCESS,
  FETCH_SHOP_COLLECTION_FAILURE,
  UPDATE_SHOP_COLLECTION
}
